import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Route, Switch } from 'react-router-dom';
import { Spacer } from '@kizen/kds/Spacer';
import {
  SubNavigationNavBar,
  SubNavigationNavLink,
} from 'components/Navigation/SubNavigation';
import { Toolbar } from '__pages/Common/styles/ControlBar';
import BackButton from '__components/Button/BackButton';
import { SettingsContentCard } from '__components/Card/Card';
import { PageSizing } from '__components/Layout/PageContentWidth';
import { PageToolbarTitle } from '__components/Layout/PageToolbar';

const StyledToolbarSide = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 15px;
`;

export type DetailsPageTab = {
  label: string;
  path: string;
  icon: string;
  badge?: boolean;
  content: ReactNode;
};

type DetailsPageShellProps = {
  title?: string;
  backTo: string;
  backLabel: string;
  actions?: ReactNode;
  tabs: DetailsPageTab[];
  currentSearch?: string;
  fallback?: ReactNode;
  children?: ReactNode;
};

export const DetailsPageShell = ({
  title,
  backTo,
  backLabel,
  actions,
  tabs,
  currentSearch,
  fallback,
  children,
}: DetailsPageShellProps) => (
  <div>
    <Spacer size={20} />
    {tabs.length > 1 ? (
      <SubNavigationNavBar>
        {tabs.map((tab, index) => (
          <SubNavigationNavLink
            key={`${tab.path}-link`}
            route={{
              label: tab.label,
              path: tab.path,
              icon: tab.icon,
              badge: tab.badge,
              exact: true,
            }}
            currentSearch={currentSearch}
            numberOfLinks={tabs.length}
            isLast={index === tabs.length - 1}
          />
        ))}
      </SubNavigationNavBar>
    ) : null}
    <Spacer size={20} />
    <PageSizing>
      <Toolbar>
        <StyledToolbarSide>
          <BackButton to={backTo}>{backLabel}</BackButton>
        </StyledToolbarSide>
        <PageToolbarTitle>{title}</PageToolbarTitle>
        <StyledToolbarSide className="justify-end">{actions}</StyledToolbarSide>
      </Toolbar>
    </PageSizing>
    <Spacer size={20} />
    <Switch>
      {tabs.map((tab) => (
        <Route key={tab.path} exact path={tab.path}>
          <PageSizing>
            <SettingsContentCard>{tab.content}</SettingsContentCard>
            <Spacer size={30} />
          </PageSizing>
        </Route>
      ))}
      {fallback}
    </Switch>
    {children}
  </div>
);
